const HeroSection = () => {
  return (
    <section className="relative w-full h-[800px]">
            <div className="relative w-full h-[100%] bg-atelier-page-hero bg-center bg-cover">
                <div className="absolute top-0 left-0 w-full h-full bg-[#41220E] bg-opacity-70 flex items-center justify-center">
                    <div className="w-[60%] flex flex-col items-center justify-center mt-[100px]">
                        <h1 className="text-[60px] xs:text-[50px] sm:text-[80px] xl:text-[100px] font-bold font-playfair text-[#F5E9D7] text-center">ATELIER</h1>
                        <p className="xs:text-[20px] text-[25px] xl:text-[22px] font-medium font-montserrat text-[#F5E9D7] text-center mt-8">Step into our creative space where passion for baking and chocolate comes alive. Join our hands-on workshops and unleash your inner artisan!</p>
                    </div>
                </div>
            </div>
    </section>
  )
}

export default HeroSection
